import request from './request';
export var getPriceRangeInfo = function getPriceRangeInfo(options) {
  var endPoint = 'https://startingpriceapi.financialflows.cimpress.io/v1/startingPriceRangeInfo';
  return request(endPoint, 'POST', JSON.stringify(options)).then(function (result) {
    if (!result || !result.errorResponse) {
      return result;
    }

    return null;
  });
};